// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4EuUf","loader":"styles_loader__gmjCv"};